import { render, staticRenderFns } from "./workNews.vue?vue&type=template&id=6784ee1c&scoped=true&"
import script from "./workNews.vue?vue&type=script&lang=js&"
export * from "./workNews.vue?vue&type=script&lang=js&"
import style0 from "./workNews.vue?vue&type=style&index=0&id=6784ee1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6784ee1c",
  null
  
)

export default component.exports